/*
 * @Date: 2019-08-22 14:30:27
 * @LastEditors: x
 * @LastEditTime: 2022-01-10 10:29:36
 */
import ticketApi from '../../api/ticket'

const actions = {
  sendTicketQuestion(context, data) {
    return ticketApi.sendTicketQuestion(data)
  },
  getTicketDetail() {
    return ticketApi.getTicketDetail()
  },
  getHadReplay() {
    return ticketApi.getHadReplay()
  },
  /**
 * @description: 是否有正在处理的工单
 */  
   getHadNoReply() {
    return ticketApi.getHadNoReply()
  }
}

export default {
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/ticket.js